import { render, staticRenderFns } from "./InspirationListPage.vue?vue&type=template&id=f161ba2e"
import script from "./InspirationListPage.vue?vue&type=script&lang=js"
export * from "./InspirationListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports